import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import ImageWithPreview from '../ImageWithPreview';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  root: {
    display: 'inline-block',
  },
  deleteBtn: {
    marginLeft: -55,
  },
});

const ImgWrapper = withStyles(styles)(props => {
  const { photo, onDelete: onDeleteParent, classes } = props;
  const onDelete = React.useCallback(() => {
    onDeleteParent && onDeleteParent(photo);
  }, [photo]);
  return (
    <div className={classes.root}>
      {props.children}{' '}
      <IconButton color="secondary" onClick={onDelete} className={classes.deleteBtn}>
        <DeleteIcon />
      </IconButton>
    </div>
  );
});

export default function PhotoCatalog(props) {
  const { photoUrls, editable, onItemDelete } = props;
  const Wrapper = React.useMemo(() => {
    if (!editable) return React.Fragment;
    return ImgWrapper;
  }, [editable]);
  return (
    <div>
      {photoUrls.length > 0 && (
        <div style={{ marginTop: 10 }}>
          {photoUrls.map((p, ii) => {
            const wrapperProps = { key: ii };
            if (editable) {
              wrapperProps.photo = p;
              wrapperProps.onDelete = onItemDelete;
            }
            return (
              <Wrapper {...wrapperProps}>
                <ImageWithPreview src={p.url} width="100" height="100" />
              </Wrapper>
            );
          })}
        </div>
      )}
    </div>
  );
}
